

export const textFound = '#4e69f2';
export const textNotFound = '#f56e6e';
